import React from 'react'
import { Table } from 'react-bootstrap'
import { formatMoney } from '../../../helpers/utils'
import { SPECIAL_PRICE_DETAIL_PRODUCT_TABLE_COLUMNS } from '../constant/specialPriceViewConstants'

const SpecialPriceProductTable = ({ details }) => {
  return (
    <Table hover responsive>
      <thead className="table-header-gray-poc">
        <tr>
          {SPECIAL_PRICE_DETAIL_PRODUCT_TABLE_COLUMNS.map((column) => (
            <th
              key={column.key}
              className={column.headerClassName}
            >
              <span className="th-header-text">{column.label}</span>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{details.product?.db_ref || '-'}</td>
          <td>
            {details.product?.id ? (
              <a
                className="special-price-link"
                href={`/productos/${details.product.id}/detalles`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {details.product?.name}
              </a>
            ) : (
              details.product?.name || '-'
            )}
          </td>
          <td>{details.sales_unit || '-'}</td>
          <td className="special-price-table__align-right">{formatMoney(details.base_price)}</td>
        </tr>
      </tbody>
    </Table>
  )
}

export default SpecialPriceProductTable
